@if (avatarImgSrc) {
  <div class="user-avatar" [class.active]="isActive">
    @if (messagesCount > 0) {
      <div class="user-avatar-badge"></div>
    }

    <!-- 目前沒有此需求 故先行註解 -->
    <!-- @if (bounsCount !== null && bounsCount > 0) {
      <span class="badge">{{ bounsCount > 99 ? '99+' : bounsCount }}</span>
    } -->

    <img class="avatar" [class]="size" [src]="avatarImgSrc || ''" [attr.alt]="'avatar' | translate" lazy="loading" />
    @if (vipImgSrc) {
      <img class="avatar-vip" [class]="size" [src]="vipImgSrc || ''" [attr.alt]="'loyalty_program_level' | translate" lazy="loading" />
    }
  </div>
}
